import { Box, Divider, List, ListItem, Paper, Typography } from "@mui/material";
import React, { FC } from "react";
import UserInfoTooltipHook from "../../user-info/user-info-click-tooltip-hook";

const DataGridUserInfoCell: FC<{ users: string[] }> = ({ users }) => {
  return (
    <Paper>
      <List>
        {users.map((userEmail: string, index: number) => (
          <Box key={userEmail}>
            <ListItem >
              <Typography key={userEmail} variant="body2" style={{ padding: 8 }}>
                {userEmail}
              </Typography>
              <UserInfoTooltipHook userEmail={userEmail} />
            </ListItem>
            {index !== users.length - 1 && (
              <Box m={1}>
                <Divider />
              </Box>
            )}
          </Box>
        ))}
      </List>
    </Paper>
  );
};

export default DataGridUserInfoCell;
